import StockTakeListTable from './stockTakeListTable.container';

export default StockTakeListTable